/**
 * Composable for interacting with Mixpanel third
 * party APIs.
 */
export function useMixpanel() {
  /**
   * Send an event to Mixpanel analytics
   * @param {string} eventName - The name of the event to track
   * @param {Record<string, unknown>} opts - Additional options for the event
   */
  function track(eventName: string, opts?: Record<string, unknown>) {
    if (typeof window === 'undefined' || !window.mixpanel) {
      console.warn('Mixpanel is not available');
      return;
    }

    window.mixpanel.track(eventName, opts);
  }

  /**
   * Register super properties with Mixpanel analytics.
   * @param {Record<string, unknown>} properties - Properties to register as super properties.
   */
  function register(properties: Record<string, unknown>) {
    if (typeof window === 'undefined' || !window.mixpanel) {
      console.warn('Mixpanel is not available');
      return;
    }

    window.mixpanel.register(properties);
  }

  return {
    track,
    register
  };
}
